
import React, { useEffect, useState, useRef } from "react";
import {
  AddCircleOutline,
  Delete,
  Edit,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import {
  Button,
  IconButton,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PayrollViewController from "../../redux/actions/payrollApiAction";
import PayRollFormModal from "./AddPayRoll";
import PayrollView from "./ViewPayRoll";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import EmployeePayrollView from "./ViewEmployeePayroll";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import "../../styles/styles.css";
import "../../styles/layout.css";
import AddSalaryReportMonth from "./AddReportmonth";
import usePermission from "../../utils/usePermission";

const PayrollListPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const { getEmployeePaySlip, deletePayroll, getEmployeePayroll } = PayrollViewController();
  const { payslips, payroll } = useSelector((state) => state.payslip);

  const [showModal, setShowModal] = useState(false);
  const [editPayroll, setEditPayroll] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const [employeeViewOpen, setEmployeeViewOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [multipleEmployees, setMultipleEmployees] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const { hasPermission } = usePermission();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);

  const buttonRef = useRef(null);

  const now = new Date();
  const currentMonth = (now.getMonth() + 1).toString(); // 1-indexed
  const currentYear = now.getFullYear().toString();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

 

  useEffect(() => {
    dispatch(getEmployeePayroll());
    dispatch(getEmployeePaySlip());
  }, [dispatch]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedRows([]);
  };

  const handleDelete = (id) => dispatch(deletePayroll(id));

  const handleEdit = (payroll) => {
    setEditPayroll(payroll);
    setShowModal(true);
  };

  const handleView = (payroll) => {
    setSelectedPayroll(payroll);
    setViewModalOpen(true);
  };

  const handleEmployeeView = (employee) => {
    setSelectedEmployee(employee);
    setEmployeeViewOpen(true);
  };

  const clearEmployeeSelection = () => {
  if (gridRef.current) {
    gridRef.current.deselectAll(); // gridRef has AG Grid API
  }
  setSelectedRows([]);
  setShowSuccessDialog(false);
};

const displayedEmployees = searchTerm
  ? payroll.filter(emp =>
      emp.employee_name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : payroll;

  const employeeColumnDefs = [
    { headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 50, pinned: "left" },
    { headerName: "SR. No", valueGetter: (params) => params.node.rowIndex + 1, maxWidth: 80 },
    { headerName: "Employee ID", field: "emp_id", flex: 1 },
    { headerName: "Employee Name", field: "employee_name", flex: 1 },
    { headerName: "Basic Salary", field: "basic_salary", flex: 1 },
    {
      headerName: payroll?.[0]?.last_month
        ? `${payroll[0].last_month} Present Days`
        : "Present Days",
      field: "present_days_last_month",
      flex: 1,
      valueGetter: (params) => params.data.present_days_last_month ?? "N/A",
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEmployeeView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const payrollColumnDefs = [
    { headerName: "SR. No", valueGetter: (params) => params.node.rowIndex + 1, maxWidth: 80 },
    { headerName: "Employee", field: "employee_name", flex: 1 },
    {
      headerName: "Month",
      field: "month",
      flex: 1,
      valueGetter: (params) => {
        if (!params.data.month) return "N/A";
        const date = new Date(params.data.month);
        return date.toLocaleString("default", { month: "long", year: "numeric" });
      },
    },
    {
      headerName: "Net Salary",
      field: "salary.net_salary",
      flex: 1,
      valueGetter: (params) => {
        return params.data.salary?.net_salary?.toFixed(2) ?? "N/A";
      },
    },
    {
      headerName: "Generated At",
      field: "generated_at",
      flex: 1,
      valueGetter: (params) => {
        if (!params.data.generated_at) return "N/A";
        const date = new Date(params.data.generated_at);
        return date.toLocaleString("en-IN");
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="View">
            <IconButton color="primary" size="small" onClick={() => handleView(params.data)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const filteredPayslips = payslips?.filter((item) => {
    const date = new Date(item.month);
    const matchesMonth = selectedMonth ? date.getMonth() + 1 === parseInt(selectedMonth) : true;
    const matchesYear = selectedYear ? date.getFullYear() === parseInt(selectedYear) : true;
    return matchesMonth && matchesYear;
  }) || [];

  const yearOptions = Array.from({ length: 5 }, (_, i) => parseInt(currentYear) - 2 + i);

  return (
    <div>
     
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          {/* Left side: Conditionally show Add Payroll or Generate Salary Report */}
          <div className="d-flex align-items-center gap-2">
            {activeTab === 0 && hasPermission("payrolls", "create")&& (
              <Button
                variant="contained"
                startIcon={<AddCircleOutline />}
                disabled={selectedRows.length === 0}
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setEditPayroll(selectedRows[0]);
                    setMultipleEmployees([]);
                  } else {
                    setEditPayroll(null);
                    setMultipleEmployees(selectedRows);
                  }
                  setShowModal(true);
                }}
                sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",             
                fontSize: "0.875rem",       
                minWidth: "140px",          
              }}
              >
                Add Payroll
              </Button>
            )}

            {activeTab === 1 && hasPermission("payrolls", "generate_report")&&(
              <Button
                ref={buttonRef}
                variant="contained"
                color="primary"
                onClick={() => setShowGenerateModal(true)}
                sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",             
                fontSize: "0.875rem",                 
              }}
              >
                Generate Salary Report
              </Button>
            )}
          </div>
          <div style={{ flexGrow: 1 }}>
    <input
      type="text"
      className="form-control"
      placeholder="Search..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{ height: "40px" }}
    />
  </div>

          {/* Right side: Always show PageSizeSelector */}
          <div>
            <PageSizeSelector
              pageSize={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            />
          </div>
        </div>
      <div className="label-card">
        <Row className="align-items-center justify-content-between w-100">
          <Col md="auto">
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Employee List" />
              <Tab label="Payroll List" />
            </Tabs>
          </Col>

          {activeTab === 1 && (
            <Col md="auto" className="d-flex align-items-center gap-2">
              {/* Month Dropdown */}
              <FormControl size="small" style={{ minWidth: 120 }}>
                <InputLabel id="month-select-label">Month</InputLabel>
                <Select
                  labelId="month-select-label"
                  id="month-select"
                  value={selectedMonth}
                  label="Month"
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected === "") return "All Months";
                    const monthIndex = parseInt(selected, 10) - 1;
                    return new Date(0, monthIndex).toLocaleString("default", { month: "long" });
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5,
                      },
                    },
                  }}
                >
                  <MenuItem value="">All Months</MenuItem>
                  {Array.from({ length: 12 }, (_, i) => (
                    <MenuItem key={i + 1} value={(i + 1).toString()}>
                      {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Year Dropdown */}
              <FormControl size="small" style={{ minWidth: 120 }}>
                <InputLabel id="year-select-label">Year</InputLabel>
                <Select
                  labelId="year-select-label"
                  id="year-select"
                  value={selectedYear}
                  label="Year"
                  onChange={(e) => setSelectedYear(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5,
                      },
                    },
                  }}
                >
                  {yearOptions.map((year) => (
                    <MenuItem key={year} value={year.toString()}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
          )}
          
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        {activeTab === 0 && (
          <ReusableGrid
           rowData={displayedEmployees}
           
            columnDefs={employeeColumnDefs}
            gridRef={gridRef}
            pagination={true}
            pageSize={pageSize}
            onSelectionChanged={(rows) => setSelectedRows(rows)}
            quickFilterText={searchTerm}
          />
        )}
        {activeTab === 1 && (
          <ReusableGrid
            rowData={filteredPayslips.filter((item) =>
    `${item.employee_name || ""} ${item.emp_id || ""}`.toLowerCase().includes(searchTerm.toLowerCase())
  )}
            columnDefs={payrollColumnDefs}
            gridRef={gridRef}
            pagination={true}
            pageSize={pageSize}
            onSelectionChanged={(rows) => setSelectedRows(rows)}
          />
        )}
      </div>

      <PayRollFormModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setEditPayroll(null);
          setMultipleEmployees([]);
        }}
        onSuccess={() => setShowSuccessDialog(true)} 
        initialData={editPayroll}
        multipleData={multipleEmployees}
        
      />
      {activeTab === 1 && showGenerateModal && (
  <AddSalaryReportMonth
    show={showGenerateModal}
    handleClose={() => setShowGenerateModal(false)}
  />
)}

      {activeTab === 1 && (
        <PayrollView
          show={viewModalOpen}
          handleClose={() => setViewModalOpen(false)}
          payroll={selectedPayroll}
        />
      )}

      {activeTab === 0 && (
        <EmployeePayrollView
          show={employeeViewOpen}
          handleClose={() => setEmployeeViewOpen(false)}
          payroll={selectedEmployee}
        />
      )}
       <Dialog open={showSuccessDialog} onClose={() => setShowSuccessDialog(false)}>
  <DialogTitle>
    <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
      🎉 Payroll Generated
    </Typography>
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      You have successfully generated payroll for <strong>{selectedRows.length}</strong> employee
      {selectedRows.length > 1 ? "s" : ""}. Would you like to clear the current selection?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Box display="flex" justifyContent="space-between" width="100%" px={2}>
      <Button
        onClick={() => setShowSuccessDialog(false)}
        variant="outlined"
        color="inherit"
        sx={{ borderRadius: 2 }}
      >
        Keep Selection
      </Button>

      <Button
        onClick={clearEmployeeSelection}
        variant="contained"
        color="success"
        sx={{ borderRadius: 2 }}
      >
        Clear Selection
      </Button>
    </Box>
  </DialogActions>
</Dialog>




    </div>
  );
};

export default PayrollListPage;
































// import React, { useEffect, useState, useRef } from "react";
// import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
// import { Button, IconButton, Tooltip } from "@mui/material";
// import { Row, Col } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import PayrollViewController from "../../redux/actions/payrollApiAction";
// import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
// import PayRollFormModal from "./AddPayRoll";
// // import PayrollViewModal from "./PayrollViewModal"; // Uncomment if you create this
// import ReusableGrid from "../../components/ag grid/ReusableGrid";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import ExportButton from "../../components/ag grid/ExportButton";

// import "../../styles/styles.css";
// import "../../styles/layout.css";
// import PayrollView from "./ViewPayRoll";

// const PayrollListPage = () => {
//   const dispatch = useDispatch();
//   const gridRef = useRef(null);

//   const { getEmployees } = EmployeeProfileVeiwController();
//   const { getEmployeePaySlip, deletePayroll } = PayrollViewController();
//   const { payslips } = useSelector((state) => state.payslip);

//   const [showModal, setShowModal] = useState(false);
//   const [editPayroll, setEditPayroll] = useState(null);
//   const [viewModalOpen, setViewModalOpen] = useState(false); // Uncomment if using PayrollViewModal
//   const [selectedPayroll, setSelectedPayroll] = useState(null); // Uncomment if using PayrollViewModal
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     dispatch(getEmployees());
//     dispatch(getEmployeePaySlip());
//   }, [dispatch]);

//   const handleDelete = (id) => dispatch(deletePayroll(id));

//   const handleEdit = (payroll) => {
//     setEditPayroll(payroll);
//     setShowModal(true);
//   };

//   const handleView = (payroll) => {
//     setSelectedPayroll(payroll);
//     setViewModalOpen(true);
//   };

// const columnDefs = [
//   {
//     headerCheckboxSelection: true,
//     checkboxSelection: true,
//     maxWidth: 50,
//     pinned: "left",
//   },
//   {
//     headerName: "SR.No",
//     valueGetter: (params) => params.node.rowIndex + 1,
//     maxWidth: 80,
//   },
//   {
//     headerName: "Employee",
//     field: "employee_name",
//     flex: 1,
//   },
//   {
//     headerName: "Month",
//     field: "month",
//     flex: 1,
//     valueGetter: (params) => {
//       const date = new Date(params.data.month);
//       return date.toLocaleString("default", { month: "long", year: "numeric" });
//     },
//   },
//   {
//     headerName: "Net Salary",
//     field: "salary.net_salary",
//     flex: 1,
//     valueGetter: (params) => params.data.salary?.net_salary ?? "N/A",
//   },
//   {
//     headerName: "Generated At",
//     field: "generated_at",
//     flex: 1,
//     valueGetter: (params) => {
//       const date = new Date(params.data.generated_at);
//       return date.toLocaleString(); // You can customize format if needed
//     },
//   },

// ];



//   return (
//     <div>
//       <div className="d-flex justify-content-between mb-3">
//         <div>
//           {selectedRows.length > 0 && (
//             <ExportButton
//               gridRef={gridRef}
//               fileName="payrolls.xlsx"
//               exportColumns={["employee_name", "net_salary"]}
//             />
//           )}
//         </div>

//         <Button
//           variant="contained"
//           startIcon={<AddCircleOutline />}
//           onClick={() => {
//             setEditPayroll(null);
//             setShowModal(true);
//           }}
//         >
//           Add Payroll
//         </Button>
//       </div>

//       <div className="label-card">
//         <Row className="justify-content-between w-100">
//           <Col>
//             <h3>Payroll List</h3>
//           </Col>
//         </Row>
//       </div>

//       <div className="ag-theme-material" style={{ height: "70vh" }}>
//         <ReusableGrid
//           rowData={payslips}
//           columnDefs={columnDefs}
//           gridRef={gridRef}
//           pagination={true}
//           onSelectionChanged={(rows) => setSelectedRows(rows)}
//         />
//       </div>

//       <PayRollFormModal
//         show={showModal}
//         onClose={() => setShowModal(false)}
//         initialData={editPayroll}
//       />

//       {/* Uncomment this block if you implement PayrollViewModal */}
//       <PayrollView
//         show={viewModalOpen}
//         handleClose={() => setViewModalOpen(false)}
//         payroll={selectedPayroll}
//       />
//     </div>
//   );
// };

// export default PayrollListPage;
